import React, { Component } from "react";


class ContainerLeftG extends Component {
  render() {
    return (
      <div 
         className="col-right2 animate-element wow delay5 fadeInDown">
        <div className="flat-space">
        <div className="flat-title t1">
       
          <h2 className="title-section color-d12 mg-b34">
            I developed 2 Games one with Python and one with JavaScript
          </h2>
      
        </div>
        </div> 
        </div>
      
    );
  }
}

export default ContainerLeftG;
